// api/userApi.js
import { apiRequest } from '@/api'

export const userApi = {
  getUsers() {
    return apiRequest('/api/users')
  },

  // ✅ 可作为加工人的用户（主/生产/外雇）
  getWorkableUsers() {
    return apiRequest('/api/users?type=workable')
  },

  // ✅ 只获取外雇人员
  getOutsourcedUsers() {
    return apiRequest('/api/users?type=outsourced')
  },

  getMainUsers(excludeSelf = true) {
    const params = new URLSearchParams({
      type: 'main',
      exclude_self: excludeSelf ? 'true' : 'false'
    })
    return apiRequest(`/api/users?${params}`)
  },

  getAssistants(mainUserId = null) {
    const params = new URLSearchParams({
      type: 'assistant'
    })
    if (mainUserId) {
      params.append('main_user_id', mainUserId)
    }
    return apiRequest(`/api/users?${params}`)
  },

  addUser(username, password, permissions, positionId, mainUserId, userType) {
    return apiRequest('/api/users/add', {
      method: 'POST',
      body: {
        username,
        password,
        permissions,
        position_id: positionId,
        main_user_id: mainUserId || null,
        user_type: userType || 'main'
      }
    })
  },

  updateUser(username, updates) {
    return apiRequest('/api/users/update', {
      method: 'POST',
      body: { username, ...updates }
    })
  },

  deleteUser(username) {
    return apiRequest('/api/users/delete', {
      method: 'POST',
      body: { username }
    })
  },

  getPositions() {
    return apiRequest('/api/positions')
  },

  createPosition(name, permissions) {
    return apiRequest('/api/positions', {
      method: 'POST',
      body: { name, permissions }
    })
  },

  updatePosition(id, name, permissions) {
    return apiRequest('/api/positions', {
      method: 'PUT',
      body: { id, name, permissions }
    })
  },

  deletePosition(id) {
    return apiRequest('/api/positions', {
      method: 'DELETE',
      body: { id }
    })
  },

  getPermissions() {
    return apiRequest('/api/permissions')
  }
}